module.exports = __webpack_public_path__ + "img/ambulance.edfa5310.jpg";